import React from 'react';
export function TopBar() {
  return <div className="w-full border-b border-gold/30 bg-cream/95 backdrop-blur-sm sticky top-0 z-40 py-3" data-id="element-71">
      <div className="max-w-3xl mx-auto px-4 text-center" data-id="element-72">
        <span className="font-sans text-[10px] sm:text-xs font-semibold tracking-[0.2em] text-burgundy uppercase" data-id="element-73">
          Investigación Independiente <span className="text-gold mx-2" data-id="element-74">|</span>{' '}
          Belleza Natural 2025
        </span>
      </div>
    </div>;
}